import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="webhook-payload-copy"
// Copies the delivered webhook payload (exact bytes) to the clipboard.
export default class extends Controller {
  static targets = ["body"]

  copy() {
    navigator.clipboard.writeText(this.bodyTarget.textContent).then(() => {
      this.flash(window.I18n["views.webhook_deliveries.show.copied"]);
    }).catch(() => {
      this.flash(window.I18n["views.webhook_deliveries.show.copy_failed"]);
    });
  }

  flash(message) {
    const button = this.element.querySelector("button[data-action]");
    if (!button) return;
    const original = button.textContent;
    button.textContent = message;
    setTimeout(() => { button.textContent = original; }, 2000);
  }
}
